<template>
    <div class="speed-data-section">
        <!-- 模块标题 -->
        <h3 style="margin-bottom:10px;">3.5、速度与转速对比分析</h3>
        <el-table :data="tableData" border :cell-style="cellStyle" :header-cell-style="headerCellStyle">
            <!-- 转速列（首列） -->
            <el-table-column label="转速-速度" prop="Title" width="50" align="center" />
            <!-- 速度区间列（横向表头） -->
            <el-table-column v-for="(speed, idx) in speedHeaders" :key="idx" :label="speed.title" :prop="speed.key"
                align="center" width="42">
                <template slot-scope="scope">
                    {{ scope.row[speed.key] || '0.00' }}
                </template>
            </el-table-column>
            <!-- 累计列 -->
            <el-table-column label="累计" prop="Total" width="50" align="center" />
        </el-table>

        <div class="table-caption">数据表5</div>

        <!-- 说明文本 -->

    </div>
</template>

<script>

export default {
    name: "VehicleEngineSpeedCompareData",
    props: {
        speedEngineRevChart: {
            type: Array,
            default: () => ([])
        }
    },
    watch: {
        speedEngineRevChart: {
            handler(newVal, oldVal) {
                if (newVal.length > 0) {
                    this.updateChart();
                }
            },
            deep: true
        }
    },
    data() {
        return {
            // 速度区间表头（横向列）
            speedHeaders: [
                { title: '0', key: 'B0' },
                { title: '≤10', key: 'B10' },
                { title: '≤20', key: 'B20' },
                { title: '≤30', key: 'B30' },
                { title: '≤40', key: 'B40' },
                { title: '≤50', key: 'B50' },
                { title: '≤60', key: 'B60' },
                { title: '≤70', key: 'B70' },
                { title: '≤80', key: 'B80' },
                { title: '≤90', key: 'B90' },
                { title: '≤100', key: 'B100' },
                { title: '≤110', key: 'B110' },
                { title: '≤120', key: 'B120' },
                { title: '>120', key: 'H120' },],
            // 表格数据：转速为行，速度区间为列
            tableData: [

            ]

        };
    },
    mounted() {

    },
    beforeDestroy() {

    },
    methods: {
        updateChart() {
         
            this.tableData = this.speedEngineRevChart
                   
        },
        // 表头样式：转速列浅灰，速度区间列浅蓝
        headerCellStyle({ columnIndex }) {
            if (columnIndex === 0) return { 'background-color': '#f5f7fa' };
            return { 'background-color': '#e6f7ff' };
        },
        // 单元格样式：按数值着色，关键数值高亮
        cellStyle({ row, columnIndex }) {
            if (columnIndex === 0) return {};
            if (row['Title'] === '累计') return {};
            
         
            const speedColKey = this.speedHeaders[columnIndex - 1]?.key;
            const cellValue = row[speedColKey] || '0.00';
            const value = Number(cellValue);

            if (value == 0) return { 'background-color': '#ffffff' };
            else if (value > 0 && value <= 0.05) return { 'background-color': '#FFEFDB' };
            else if (value > 0.05 && value <= 0.1) return { 'background-color': '#EEE5DE' };
            else if (value > 0.1 && value <= 0.2) return { 'background-color': '#FFE4B5' };
            else if (value > 0.2 && value <= 0.3) return { 'background-color': '#E0FFFF' };
            else if (value > 0.3 && value <= 0.4) return { 'background-color': '#BFEFFF' };
            else if (value > 0.4 && value <= 0.5) return { 'background-color': '#AEEEEE' };
            else if (value > 0.5 && value <= 1) return { 'background-color': '#8DEEEE' };
            else if (value > 1 && value <= 5) return { 'background-color': '#CD950C' };
            else if (value > 5 && value <= 10) return { 'background-color': '#EE7600' };
            else if (value > 10 && value <= 15) return { 'background-color': '#CD4F39' };
            else if (value > 15) return { 'background-color': '#FF0000' };
            
            return {};
        }

    }
};
</script>
<style scoped></style>